import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { PageHeader } from "@/components";
import { ROUTE_CONFIG } from "@/routes/config";

import { BlacklistView } from "./pages/BlacklistView";
import { CompetitorsView } from "./pages/CompetitorsView";
import { SuppressedView } from "./pages/SuppressedView";

/** The tabs of Do-not-contact, in their order (PREC-4266): each is a route segment. */
export const DO_NOT_CONTACT_TABS = ["competitors", "blacklist", "suppressed"] as const;

/** The tab a path shows: its last segment when it names a tab, else the first tab. */
export const activeDoNotContactTab = (pathname: string): string => {
	const segment = pathname.replace(/\/+$/, "").split("/").pop() ?? "";

	return (DO_NOT_CONTACT_TABS as readonly string[]).includes(segment)
		? segment
		: DO_NOT_CONTACT_TABS[0];
};

export const DoNotContact: FunctionComponent = () => {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const navigate = useNavigate();

	return (
		<div className="flex flex-col h-full w-full">
			<PageHeader
				activeTab={activeDoNotContactTab(pathname)}
				tabs={DO_NOT_CONTACT_TABS.map((tab) => ({
					label: t(`contacts.tabs.${tab}`),
					value: tab,
				}))}
				title={t("contacts.tabs.doNotContact")}
				onTabChange={(tab) => navigate(`${ROUTE_CONFIG.DO_NOT_CONTACT}/${tab}`)}
			/>
			<Routes>
				<Route index element={<Navigate replace to="competitors" />} />
				<Route element={<CompetitorsView />} path="competitors" />
				<Route element={<BlacklistView />} path="blacklist" />
				<Route element={<SuppressedView />} path="suppressed" />
			</Routes>
		</div>
	);
};
